import jsbridge from '@xpeng/js-bridge'
import { CAR_INFO, LOGIN_STATE, LOCATION } from './data'

const __callHandler__ = jsbridge.callHandler

jsbridge.callHandler = function (method: any, params?: {}) {
  console.log('[Mock Bridge]', method, params)

  if (method === 'getCarInfo') {
    return Promise.resolve({
      code: 0,
      data: CAR_INFO,
    })
  }

  if (method === 'getLoginState') {
    return Promise.resolve({
      code: 0,
      loginState: 1,
      data: LOGIN_STATE,
    })
  }

  if (method === 'requestLocation') {
    return Promise.resolve({
      code: 0,
      data: LOCATION,
    })
  }

  return __callHandler__.apply(jsbridge, [method, params])
}
